<canvas
  [width]="width()"
  [height]="height()"
  (mousedown)="startDrawing($event)"
  (mousemove)="draw($event)"
  (mouseup)="stopDrawing($event)"
  (mouseleave)="stopDrawing($event)"
  (touchstart)="startDrawing($event)"
  (touchmove)="draw($event)"
  (touchend)="stopDrawing($event)"
  #signatureCanvas
></canvas>
